module.exports = __webpack_public_path__ + "img/404_Illustration.7de27afd.svg";